import { render, staticRenderFns } from "./BaseInnerInput.vue?vue&type=template&id=22ba06f1"
import script from "./BaseInnerInput.vue?vue&type=script&lang=js"
export * from "./BaseInnerInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports